import { codeHighlightingLanguages } from '@w/code-highlighting'
import { EllipsisVerticalIcon } from '@w/ui/components/icon'
import { IconButton } from '@w/ui/components/icon-button'
import { Menu, MenuTrigger, MenuPopup, MenuItem } from '@w/ui/components/menu'

/** Press menu shared by Lexical and Skia. Copy is available in every content mode. */
/** `code` may be read at the click (a getter), when the render that made the menu can predate the code it copies. */
export function CodeActionMenu({ code, onLanguageChange }: { code: string | (() => string); onLanguageChange?: (language: string) => void }) {
  return <div className="absolute top-1 right-1"><Menu>
    <MenuTrigger data-testid="content-blocks-editor-code-menu" render={<IconButton aria-label="Code actions" />}><EllipsisVerticalIcon />Code actions</MenuTrigger>
    <MenuPopup>
      <MenuItem data-testid="content-blocks-editor-code-copy" onClick={() => { void navigator.clipboard.writeText(typeof code === 'function' ? code() : code) }}>Copy code</MenuItem>
      {onLanguageChange && codeHighlightingLanguages.map(language => <MenuItem key={language} data-testid={`content-blocks-editor-code-language-${language}`} onClick={() => { onLanguageChange(language) }}>Language: {language}</MenuItem>)}
    </MenuPopup>
  </Menu></div>
}
